import React, { Fragment } from "react";
import { Form, Col, Row, Card } from "react-bootstrap";
import { ADDRESS_TYPES } from "../../../constants/constants";

import { getAddressAsString, getFormattedDate } from "../../../util/helpers";
import { getFatherOrMotherOrSpouseName, getDeclarationPlace } from "../../../util/onBoardingDataFilters";
import useValidation from "../../../util/useValidation";

const IdentityCardForm = ({
  personalDetails,
  updatePersonalDetails,
  states
}) => {
  const {
    addresses,
    declarationPlace,
    familyMembers,
    identificationMark,
    sezCardIsFatherOrMotherOrSpouse
  } = personalDetails;

  const { handleOnBlurValidation, errors } = useValidation();
  const handleOnBlurInput = e => {
    handleOnBlurValidation(e);
  };

  const handleOnChangePersonalDetails = ({ target: { name, value } }) => {
    updatePersonalDetails(name, value);
  };

  const isPuneLocation = getDeclarationPlace(declarationPlace) === "Pune"

  return (
    <Fragment>
      <Card>
        <p className="text-danger text-center">
          *** Note : This form is mandatory for Hyderabad candidates. Please
          skip, if you are from Pune location.
        </p>
        <Card.Header className="justify-content-center align-items-center text-center d-flex flex-column h-100">
          Application Form for Permanent/Temporary Identity Card
          <p className="mb-0">(To be filled by the Applicant)</p>
        </Card.Header>
        <Card.Body>
          <div className="text-center">
            <p className="font-weight-bold mb-0">CDK Global (India) Pvt Ltd.</p>
            <p className="mb-0">(Special Economic Zone)</p>
            <p className="mb-0">
              5th Floor, Building No.12 B, Sundew Properties Ltd-SEZ, Madhapur, Raheja
              Mindspace, Hyderabad, Rangareddy, Telangana – 500 081.
            </p>
          </div>
          <Row className="mb-3 mt-3">
            <Col sm={3}>
              <h6>Name Of The Company/Unit</h6>
            </Col>
            <Col sm={4}>
              <h6>CDK Global (India) Pvt. Ltd.</h6>
            </Col>
          </Row>
          <Form.Group as={Row} controlId="nameOfEmployee">
            <Form.Label column sm={3}>
              Name Of The Employee*
            </Form.Label>
            <Col sm={4}>
              <Form.Control
                size="sm"
                required={!isPuneLocation}
                placeholder="Name Of The Employee"
                type="text"
                name="nameOfEmployee"
                value={[
                  personalDetails.firstName,
                  personalDetails.middleName,
                  personalDetails.lastName
                ]
                  .filter(name => name)
                  .join(" ")}
                disabled
              />
            </Col>
            <Col sm={5} />
          </Form.Group>
          <Form.Group as={Row} controlId="designation">
            <Form.Label column sm={3}>
              Designation*
            </Form.Label>
            <Col sm={4}>
              <Form.Control
                size="sm"
                required={!isPuneLocation}
                disabled
                placeholder="Designation"
                type="text"
                name="cDKDesignation"
                value={personalDetails.cDKDesignation}
                onChange={handleOnChangePersonalDetails}
              />
            </Col>
            <Col sm={5} />
          </Form.Group>

          <Form.Group className="row-with-mb-zero-label-pt-zero" as={Row}>
            <Form.Label column sm={3}>
              {`Father’s / Mother’s / Spouse’s Name${!isPuneLocation ? '*' : ""}`}
            </Form.Label>
            <Col sm={4}>
              <div>
                <Form.Check
                  id="father-relation"
                  inline
                  label="Father"
                  name="sezCardIsFatherOrMotherOrSpouse"
                  onChange={handleOnChangePersonalDetails}
                  required={!isPuneLocation}
                  checked={sezCardIsFatherOrMotherOrSpouse == "1"}
                  type="radio"
                  value="1"
                />
                <Form.Check
                  id="mother-relation"
                  inline
                  label="Mother"
                  name="sezCardIsFatherOrMotherOrSpouse"
                  checked={sezCardIsFatherOrMotherOrSpouse == "2"}
                  onChange={handleOnChangePersonalDetails}
                  required={!isPuneLocation}
                  type="radio"
                  value="2"
                />
                <Form.Check
                  id="spouse-relation"
                  inline
                  label="Spouse"
                  name="sezCardIsFatherOrMotherOrSpouse"
                  checked={sezCardIsFatherOrMotherOrSpouse == "3"}
                  disabled={!getFatherOrMotherOrSpouseName(
                    3,
                    familyMembers
                  )}
                  onChange={handleOnChangePersonalDetails}
                  required={!isPuneLocation}
                  type="radio"
                  value="3"
                />
              </div>
            </Col>
            <Col sm={5} />
          </Form.Group>
          <Form.Group as={Row} controlId="fatherOrMotherOrSpouseName">
            <Form.Label column sm={3}>
              {""}
            </Form.Label>
            <Col sm={4}>
              <Form.Control
                size="sm"
                required={!isPuneLocation}
                disabled
                placeholder="Father’s /Mother’s /Spouse’s Name"
                type="text"
                value={getFatherOrMotherOrSpouseName(
                  sezCardIsFatherOrMotherOrSpouse,
                  familyMembers
                )}
                onChange={handleOnChangePersonalDetails}
                name="fatherOrMotherOrHusbandName"
              />
            </Col>
            <Col sm={5} />
          </Form.Group>

          <Form.Group as={Row} controlId="temporaryAddress">
            <Form.Label column sm={3}>
              Temporary Address*
            </Form.Label>
            <Col sm={4}>
              <Form.Control
                size="sm"
                required={!isPuneLocation}
                placeholder="Temporary Address"
                as="textarea"
                name="temporaryAddress"
                value={getAddressAsString(
                  ADDRESS_TYPES.CURRENT,
                  addresses,
                  states
                )}
                disabled
              />
            </Col>
            <Col sm={5} />
          </Form.Group>
          <Form.Group as={Row} controlId="permanentResidenceAddress">
            <Form.Label column sm={3}>
              Permanent Residence Address*
            </Form.Label>
            <Col sm={4}>
              <Form.Control
                size="sm"
                required={!isPuneLocation}
                placeholder="Permanent Residence Address"
                as="textarea"
                name="permanentResidenceAddress"
                value={getAddressAsString(
                  ADDRESS_TYPES.PERMANENT,
                  addresses,
                  states
                )}
                disabled
              />
            </Col>
            <Col sm={5} />
          </Form.Group>
          <Form.Group as={Row} controlId="dateofBirth">
            <Form.Label column sm={3}>
              Date of Birth*
            </Form.Label>
            <Col sm={4}>
              <Form.Control
                size="sm"
                required={!isPuneLocation}
                placeholder="Date of Birth"
                type="date"
                name="birthDate"
                value={getFormattedDate(
                  personalDetails.birthDate,
                  undefined,
                  "YYYY-MM-DD"
                )}
                disabled
              />
            </Col>
            <Col sm={5} />
          </Form.Group>
          <Form.Group as={Row} controlId="dateofBirth">
            <Form.Label column sm={3}>
              Date of Joining*
            </Form.Label>
            <Col sm={4}>
              <Form.Control
                size="sm"
                required={!isPuneLocation}
                placeholder="Date of Joining"
                type="date"
                name="dateofJoining"
                value={getFormattedDate(
                  personalDetails.dateofJoining,
                  undefined,
                  "YYYY-MM-DD"
                )}
                disabled
              />
            </Col>
            <Col sm={5} />
          </Form.Group>
          <Form.Group as={Row} controlId="identificationMark">
            <Form.Label column sm={3}>
                {`Identification Mark${!isPuneLocation ? '*' : ""}`}
            </Form.Label>
            <Col sm={4}>
              <Form.Control
                size="sm"
                required={!isPuneLocation}
                placeholder="Identification Mark"
                onChange={handleOnChangePersonalDetails}
                type="text"
                name="identificationMark"
                value={identificationMark}
                onBlur={handleOnBlurInput}
                isInvalid={errors.identificationMark}
              />
              {errors.identificationMark && (
                <Form.Control.Feedback type="invalid">
                  {errors.identificationMark.type === "required" &&
                    "Identification Mark is required"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={5} />
          </Form.Group>
        </Card.Body>
      </Card>

      <Card>
        <Card.Body>
          <Row>
            <Col sm={4} />
            <Col sm={4} className="text-center">
              (For Office Use Only)
            </Col>
            <Col sm={4} />
          </Row>
          <p>
            Entry for
            Mr./Ms./Mrs._______________________________________________________
          </p>
          <p>
            S/o/D/o/w/o/Shri_______________________________________has been made
            in the Register of M/s CDK Global (India) Pvt. Ltd. (Special
            Economic Zone) 5th Floor, Building No. 12B, Sundew Properties Ltd-SEZ, 
            Madhapur, Raheja Mindspace, Hyderabad, Rangareddy, Telangana at Sr.No.__________at Page
            No_______. Now Mr./Ms./Mrs.___________________ is allowed to get
            entry in M/s CDK Global (India) Pvt. Ltd. (Special Economic Zone) by
            showing his Permanent identity Card, bearing
            No____________________________.
          </p>
          <Row>
            <Col sm={4} /> <Col sm={4} />
            <Col sm={4} className="text-center">
              <p>_______________________________________________</p>
              <p>(Signature of Development Commissioner)</p>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Fragment>
  );
};
export default IdentityCardForm;
